// extracted by mini-css-extract-plugin
module.exports = {"dividerLine":"dividerLine__2rwE4"};